import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import AppForm from '../../components/AppForm';
import {Button, Tooltip, OverlayTrigger, Popover, SplitButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, DateTimePicker, FileUpload, Number, ImageUpload, Select} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import Help from '../../components/Help';
import MultiCheckbox from '../../components/Form/MultiCheckbox';
import RadioList from '../../components/Form/RadioList';
import Checkbox from '../../components/Form/IconCheckbox';
import ChangeBar from '../../components/ChangeBar';
import {ModalWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import RequiredSymbol from '../../components/RequiredSymbol';
import NavBar from '../../components/NavBar';
import TableForm from "../../components/TableForm";
import {TabGroup, Tab} from 'reactis-tabs';
import immutable from 'immutable';
import ButtonToolbar from '../../components/ButtonToolbar';


@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)}
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'emailaccount.fetch',
			save: 'emailaccount.save',
			remove: 'emailaccount.delete'
		};

		this.changeEvent = 'emailaccount.change';
		this.savePushState = '/emailaccount';

		this.messages = {
			remove: 'Opravdu si přejete účet odstranit?',
			notfound: 'Účet nenalezen!'
		};

		this.schema = {
			email: {
				class: TextInput,
				label: 'E-mail',
				rules: {
					email: {message: 'Zadejte platný e-mail!'}
				}
			},
			name: {
				class: TextInput,
				label: 'Jméno'
			},
			dkim_selector: {
				class: TextInput,
				label: 'Selector'
			},
			dkim: {
				class: TextArea,
				style: {height: 200},
				label: 'Private Key'
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'email') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.email});
	}


	render() {

		const isNew = !this.props.id;
		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = 1 || this.user.isAllowed('post', isNew ? 'insert' : 'update');
		const canDelete = 1 || this.user.isAllowed('post', 'delete');

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={() => this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit jako nový',
				icon: 'fa fa-copy',
				loading: loading,
				visible: !isNew && canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save(false, true)
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				visible: !isNew && canDelete,
				bsStyle: 'danger',
				color: '#A00',
				onClick: () => this.remove()
			}
		];

		return (
			<AppForm id={this.props.tabid} form={this.form} ref="form">
				<NavBar buttons={toolbar} onClose={this.props.closeTab} title="E-mailový účet"/>
				{!this.props.popup && <Toolbar title="E-mailový účet">
					<ButtonToolbar buttons={toolbar}/>
				</Toolbar>}
				<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems}
						   onAcceptChanges={() => this.acceptChanges()}
						   onClose={() => this.setState({showChangedBar: false})}/>

				<div className="row">
					<div className="col-md-8">
						<TableForm>
							<FormRow name="email" labelWidth={135}/>
							<FormRow name="name"/>
						</TableForm>
						<br/>
						<fieldset>
							<legend>
								DKIM
								<Help>
								DomainKeys Identified Mail je technologie pro zvýšení důvěryhodnosti emailů, která též napomáhá odhalení podvržených zpráv. Odeslaná zpráva je podepsána privátním klíčem domény odesílatele a tento podpis je uložen v hlavičce emailu. Server příjemce porovná tento podpis s veřejným klíčem uloženým v DNS záznamech domény.
								</Help>
								<a style={{float: 'right'}} target="_blank" href="https://www.socketlabs.com/domainkey-dkim-generation-wizard/"><span className="fa fa-external-link"></span> DKIM Generation Wizard</a>
								<a style={{float: 'right', marginRight: 20}} target="_blank" href="http://dkimcore.org/c/keycheck"><span className="fa fa-external-link"></span> DKIM DNS Check</a>
							</legend>
							<TableForm>
								<FormRow name="dkim_selector" labelWidth={135}/>
								<FormRow name="dkim"/>
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
							</TableForm>
						</fieldset>
					</div>
				</div>
			</AppForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Emailaccount/Form.js